import { Component, ElementRef, Input, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject, filter } from 'rxjs';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog } from '@angular/material/dialog';
import { ProfileEnovskyComponent } from 'src/app/back-office/enovsky/profile-enovsky/profile-enovsky.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  constructor(private route: ActivatedRoute, private router: Router,
    private sharedService: SharedService,
    private helper: HelperModule,
    public dialog: MatDialog
  ) {}
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @Input() userInfos:  { [x:string]: any } = new Map();
  eventShareUserInfos: Subject<any> = new Subject<any>();
  eventShare = this.eventShareUserInfos.asObservable();

  currentRoute: string = '';
  inProgress = false;
  eventUpdateUserInfos: Subject<void> = new Subject<void>();
  connectedUser:{ [x:string]: any } = {id_user:'', user: "user", first_name: '', last_name: '', email:'', phone: '', connected: false, connect_msg: 'Connect as'};

  ngAfterViewInit() {
    this.sharedService.sendData({user_infos: this.userInfos});
    this.currentRoute = this.route.snapshot.firstChild?.routeConfig?.path || '';
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.currentRoute = this.route.snapshot.firstChild?.routeConfig?.path || '';
      this.sharedService.sendData({user_infos: this.userInfos});
    });
    this.sharedService.data.subscribe(data => {
      if(data['close_side_nav']){
        this.sidenav.close();
      };
    });
  }
  shareUserData(){
    this.sharedService.sendData({user_infos: this.userInfos});
  }
  signOut(){
    console.log(this.userInfos)
  }
  
}
